<template>
    <div>
        <e-dialog dialogTitle="确认提醒"
                  :centerDialogVisible="confirmReminderVisible"
                  @updateVisible="closeDialog"
                  @resetPopupData="closeDialog"
                  @submitPopupData="submitPopupData"
                  :popupWidth="'426px'">
            <div class="confirm-wrapper">
                <div class="confirm-title">订单中以下商品为易资源商品，需要缴纳平台服务费</div>
                <div class="confirm-box">
                    <div v-for="(item,index) in ESourceData" :key="index" class="confirm-content flex-sc">
                        <e-tooltip :content="item" :set-length="66"/>
                    </div>
                </div>
                <div class="flex-all-center">
                </div>
            </div>
        </e-dialog>
    </div>
</template>

<script>
  import eDialog from "@/components/common/epecDialog.vue";
  import eTooltip from "../../../components/common/e-tooltip";
  export default {
    name: "confirmReminderDialog",
    components: {eDialog,eTooltip},
    props:{
      confirmReminderVisible:Boolean,
      ESourceData:Array
    },
    methods:{
      submitPopupData(){
        this.$emit('supplierOrderConfirm','0');
      },
      closeDialog() {
        this.$emit('closeDialog');
      },

    },
  }
</script>

<style scoped lang="scss">
    @import '../../../../../assets/css/scrollbar.scss';
    .confirm-wrapper{
        font-size: 14px;
        color:#333;
        .confirm-title{
            font-weight: 500;
            margin-bottom: 20px;
        }
        .confirm-box{
            max-height: 340px;
            overflow-y: auto;
            .confirm-content{
                width: 380px;
                min-height: 34px;
                font-weight: 350;
                background-color: #F8F8F8;
                margin-bottom: 4px;
                padding:  10px;
            }
        }

    }

</style>